import axios from 'axios'

export const apiAxios = axios.create()

const projectName = 'faveback'
const region = 'europe-west3'

const stage = 'PROD' // 'PROD' | 'DEV'

/**
 * Gen2 functions are reached via Firebase Hosting rewrites (`/api/*`),
 * not the legacy `cloudfunctions.net` Gen1 URL shape.
 *
 * - Deployed app (custom domain or *.web.app): same-origin `/api/`
 * - Local Vite talking to prod: default Hosting site proxy
 * - DEV: Functions emulator
 */
function prodApiBase() {
  if (typeof window !== 'undefined') {
    const { hostname, origin } = window.location
    if (hostname && hostname !== 'localhost' && hostname !== '127.0.0.1') {
      return `${origin}/api/`
    }
  }
  return 'https://faveback-app.web.app/api/'
}

const baseURL = {
  DEV: `http://127.0.0.1:5001/${projectName}/${region}/`,
  PROD: prodApiBase(),
}

apiAxios.defaults.baseURL = baseURL[stage]
apiAxios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
